<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">

    </div>
    <div class="content-body">
      <section id="drag-area">
        <div class="row">
          <div class="col-md-12" *blockUI="'changelog'; message: 'Loading'">
            <m-card [options]="options" (reloadFunction)="reloadChangelog($event)">
              <ng-container mCardHeaderTitle>
                Ürün Grupları <button class="btn btn-primary" (click)="openSaveModal()">+ Yeni Ekle</button>
              </ng-container>
              <ng-container mCardBody>
                <div class="row mb-2">
                 
                  <div class="col-md-12">
                    Ürün Grubu Arama   <input type="text" class="form-control col-md-4" (change)="search($event)">
                  </div>
                </div>
               
                <table class="table table-bordered">
                  <thead>
                  <tr>
                    <th>Ürün Grubu</th>
                    <th>A</th>
              
                   
                    <th>İşlemler</th>
                  </tr>
                </thead>
                  <tr *ngFor="let h of filteredhammeddeler">
                    <td>{{h.name}}</td>
                    <td>{{h.a}}</td>
                  
                 
                    <td>
                      <i class="la la-edit success" (click)="openEditModal(h)" style="cursor: pointer;"></i> |
                      <i class="la la-remove danger" (click)="delete(h.id)" style="cursor: pointer;"></i>
                    </td>
                  </tr>
                </table>
              </ng-container>
            </m-card>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
